import { request } from '../handleRequest';

export const buildRequestURL = (carePlanId, id, type, recurring) => {
  let url = `/care_plans/${carePlanId}/`;

  switch (type) {
    case 'Task':
      url += recurring ? `repeated_tasks/${id}` : `tasks/${id}`;
      break;
    case 'Appointment':
      url += recurring ? `repeated_appointments/${id}` : `appointments/${id}`;
      break;
    default:
      url = '/404';
  }

  return url;
};

export const editActivityApiWrapper = (
  requestProvider = request,
  buildRequestURLProvider = buildRequestURL
) => {
  return async (carePlanId, activityId, activity, type, recurring) => {
    try {
      const body = {
        ...activity,
        type,
      };

      const endpointUrl = buildRequestURLProvider(carePlanId, activityId, type, recurring);
      const response = await requestProvider(endpointUrl, 'PATCH', body);
      const status = response.status;

      let responseBody = {};
      try {
        responseBody = await response.json();
      } catch (e) {
        console.error('Failed to parse response JSON:', e);
      }

      if (!response.ok) {
        return {
          status,
          ...(responseBody || { error: 'Unknown server error' })
        };
      }

      return {
        status,
        ...responseBody
      };

    } catch (error) {
      return {
        status: 500,
        error: error.message || 'Network request failed'
      };
    }
  };
};

export default editActivityApiWrapper(request, buildRequestURL);
